<script setup>
import bgGradient from '@/assets/img/bg-gradient-smilepicture.png'
import logo from '@/assets/img/logo_smilepicture.png'
</script>

<template>
    <section class="wrapper image-wrapper bg-content text-white d-flex align-items-center justify-content-center"
        :style="{ '--bg-image': `url(${bgGradient})` }">
        <div class="container position-relative z-10">
            <div class="row justify-content-center">
                <div class="col-lg-8 text-center">

                    <!-- Logo -->
                    <img :src="logo" alt="SmilePicture Logo" class="mb-6" style="max-width: 280px;" />

                    <!-- Title -->
                    <h2 class="display-2 text-secondary mb-3">
                        Coming Soon
                    </h2>

                    <!-- Description -->
                    <p class="lead">
                        We’re almost ready.<br>
                        Stay tuned for creative stories, impactful visuals,
                        and fresh inspiration.
                    </p>
                </div>
            </div>
        </div>
    </section>
</template>

<style scoped>
.image-wrapper {
    position: relative;
    min-height: 100vh;
}

.image-wrapper::before {
    content: "";
    position: absolute;
    inset: 0;
    background-image: var(--bg-image);
    background-size: cover;
    background-position: center;
    z-index: 0;
}

.z-10 {
    z-index: 10;
}
</style>
